/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

declare let adobeIMS: AdobeIMS;

import getConfig from '../../../config';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import platform from 'platform';

export default class SearchUtils {
	/**
	 * [getIMSData consolidates the IMS data for the current user that is passed to the view]
	 * @returns {Object} object containing IMS data for the current user
	 */
	static getIMSData() {
		const userId = window.cchome.util.getUserId();
		const imsData = {
			token: adobeIMS.getAccessToken(),
			name: adobeIMS.getUserProfile()?.first_name,
			email: adobeIMS.getUserProfile()?.email,
			userID: userId,
		};

		return imsData;
	}

	/**
	 * This method is required by all
	 * clients of the Search Component.
	 * It allows the client to pass in
	 * client specific data.
	 */
	static getCurrentClientData(planCode: string | null | undefined, stakeholder: boolean | null | undefined) {
		// For CCHome return subCategory:
		// Home, Learn, Apps
		const sCategory = AnalyticsUtil.getLeftTab();
		const userAgent = navigator.userAgent;

		// For CChome return Ingest config
		// information.
		const xApiKey = getConfig('INGEST').xApiKey;
		const apiKey = getConfig('INGEST').apiKey;
		const clientId = window.searchGlobalData.apiKey;

		const project = getConfig('INGEST').project;
		const source = getConfig('INGEST').source;
		const path = getConfig('INGEST').path;

		const hostNameStage = getConfig('INGEST').hostNameStage;
		const hostNameProd = getConfig('INGEST').hostNameProd;

		const useLocalReferrer = true;
		const referrerStorageName = 'event_referrer';

		const version = '1.0'; // need to get version
		const platformType = 'Web';
		const device = window.navigator.platform;
		const offline = false;
		const category = 'Web';
		const osVersion = platform.os.version;

		const componentName = 'CCHome';
		const componentVersion = '1.0.1';

		// Init analytics data
		const clientAnalyticsData = {
			xApiKey,
			apiKey,
			clientId,
			project,
			source,
			path,
			hostNameStage,
			hostNameProd,
			useLocalReferrer,
			referrerStorageName,
			userAgent,
			version,
			platformType,
			device,
			offline,
			category,
			osVersion,
			planCode,
			stakeholder,
			componentName,
			componentVersion,
			campaignId: AnalyticsUtil.searchCampaignId,
			variationId: AnalyticsUtil.searchVariationId,
			searchPromptId: AnalyticsUtil.searchPromptId,
			clientSubcategory: sCategory,
		};

		// Search History params
		const searchComponentData = {
			client: 'CCHome',
			surface: 'CCWeb',
		};

		// Return client data to Search component
		return {
			analyticData: clientAnalyticsData,
			search: searchComponentData,
		};
	}
}
